const $inject = ['$filter', '$q', '$http', 'APP_CONFIG'];

const travellersService = function ($filter, $q, $http, APP_CONFIG) {
  const service = {};

  service.isTravellerOnly = false;
  service.options = [];
  service.selected = [];

  service.init = function init() {
    service.isTravellerOnly = false;
    service.options = [];
    service.selected = [];
  };

  service.get = function get(query) {
    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('travellers', query);

    $http.get(apiConfig.url, { params: { query }, apiVersion: apiConfig.version })
      .then((res) => {
        let data = res.data;
        let guests = JSON.parse(sessionStorage.getItem('guestTravellers')) || [];
        let options = _.filter(_.concat(data, guests), (option) => {
          return !_.find(service.selected, { 'Email': option.Email });
        });
        service.options = $filter('filter')(options, query);
        deferred.resolve();
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  };

  service.saveGuest = function(guest) {
    let guests = JSON.parse(sessionStorage.getItem('guestTravellers')) || [];

    let existingGuest = _.find(guests, (guestTraveller) => {
      return guestTraveller.guestID === guest.guestID;
    });

    if(existingGuest) {
      existingGuest = guest;
    } else {
      guests = guests.concat([guest]);
    }

    sessionStorage.setItem('guestTravellers', JSON.stringify(guests));

    return service.selectedTravellers;
  };

  service.selectTraveller = function selectTraveller(traveller) {
    if (service.selected.length < 9) {
      let isExisitingSelectedGuestTraveller = false;

      service.selected = _.map(service.selected, (selectedTraveller) => {
        if(traveller.isGuest && selectedTraveller.guestID === traveller.guestID) {
          isExisitingSelectedGuestTraveller = true;
          return traveller;
        } else {
          return selectedTraveller;
        }
      });

      if(!isExisitingSelectedGuestTraveller) {
        service.selected = service.selected.concat([traveller]);
      }
    }
  };

  service.removeTraveller = (traveller) => {
    service.selected = _.filter(service.selected, (selectedTraveller) => {
      return selectedTraveller !== traveller;
    });

    traveller.setActive = false;
    service.options.push(traveller);

    return service.selected;
  };

  return service;
};

travellersService.$inject = $inject;

export default travellersService;



// WEBPACK FOOTER //
// ./src/services/travellersService.js